import Vue from 'vue'
import App from './App.vue'
import VModal from "vue-js-modal";
import CONSTANTS from "@/constants";
import router from './router'
import Router from "vue-router";

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from '@fortawesome/vue-fontawesome'

import {
  faAngleRight,
  faArrowRight,
  faTimes,
  faCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(faAngleRight)
library.add(faTimes);
library.add(faArrowRight);
library.add(faCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

Vue.config.productionTip = false

Vue.use(VModal, {
  dynamic: true
});
Vue.use(Router);

Vue.config.ignoredElements = ["enterprise-header", "enterprise-search"];
// Add the cloudfront dynamically & version is added with current timestamp to not cache the component
var headElement = document.getElementsByTagName("head")[0];
var componentScriptElement = document.createElement("script");
let date = new Date();
let oneHourCache = date.getMonth() + 1 + "" + date.getDate() + "" + date.getFullYear() + "" + date.getHours();
componentScriptElement.src = CONSTANTS.HH_COMPONENTS_URL + "/enterprisesearchbundle.umd.min.js?v=" + oneHourCache;
headElement.appendChild(componentScriptElement);

var componentStyleElement = document.createElement("link");
componentStyleElement.type = "text/css";
componentStyleElement.rel = "stylesheet";
componentStyleElement.href = CONSTANTS.HH_CORE_COMPONENTS_URL + "/theme.css?v=" + Date.now();
headElement.appendChild(componentStyleElement);



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')